/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { Env as LibEnv } from '@wit/vtv-x-foundation-lib';

export interface IEnvLink {
  id: string;
  url: string;
  translationKey?: string;
}
export default interface Env extends LibEnv {
  DMS_ALLOWED_APP_NAME_COMBOS: string[] | undefined;
  ABOUT_LINKS: IEnvLink[];
  SIGNIN_LINKS: {
    FORGOT_EMAIL: string;
    FORGOT_PASSWORD: string;
    MANAGE_ACCOUNT: string;
  };
  LOGIN_WITH_CODE?: boolean;
}

export enum EnvLinkKeys {
  TERMS_AND_CONDITIONS = 'Terms_And_Conditions',
}
